// --- Core ---
import PropTypes from "prop-types";
// --- Material UI ---
import {ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
// Icons
import AddIcon from "@mui/icons-material/Add";

/**
 * ListItem to push new elements to the end of a FieldArray.
 * Has a + as the actual add button and a accompanying text.
 *
 * @see ListItem
 * @example
 * <List>
 *   <For ... of={fields}>
 *     ...
 *   </For>
 *   <AddListItem fields={fields}
 *                text={"Add Element"}
 *                defaultItem={{attribute: 2}}
 *   />
 * </List>
 */
function AddListItem({fields, text, disabled, defaultItem = {}}) {
  return (
    <ListItemButton
      disabled={disabled}
      onClick={
        () => {
          fields.push(defaultItem);
        }
      }
    >
      <ListItemIcon>
        <AddIcon size="small"/>
      </ListItemIcon>
      <ListItemText primary={text}/>
    </ListItemButton>
  );
}

AddListItem.propTypes = {
  /** FieldsArrayRenderProps item from react-final-form-arrays that will be manipulated */
  fields: PropTypes.object.isRequired,
  /** Text of the ListItem */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /** Disabled state of the item */
  disabled: PropTypes.bool,
  /** Default element added to the FieldArray
   * @default {}
   */
  defaultItem: PropTypes.object
};

export {
  AddListItem
};
